<template>
    <div>
        <base-header type="gradient-success" class="pb-6 pb-8 pt-5 pt-md-8">
            <!-- Card stats -->
            <div class="row">
                <div class="col-xl-3 col-lg-6">
                    <stats-card title="Total traffic"
                                type="gradient-red"
                                sub-title="350,897"
                                icon="ni ni-active-40"
                                class="mb-4 mb-xl-0">

                        <template slot="footer">
                            <span class="text-success mr-2"><i class="fa fa-arrow-up"></i> 3.48%</span>
                            <span class="text-nowrap">Since last month</span>
                        </template>
                    </stats-card>
                </div>
                <div class="col-xl-3 col-lg-6">
                    <stats-card title="Total traffic"
                                type="gradient-orange"
                                sub-title="2,356"
                                icon="ni ni-chart-pie-35"
                                class="mb-4 mb-xl-0">

                        <template slot="footer">
                            <span class="text-success mr-2"><i class="fa fa-arrow-up"></i> 12.18%</span>
                            <span class="text-nowrap">Since last month</span>
                        </template>
                    </stats-card>
                </div>
                <div class="col-xl-3 col-lg-6">
                    <stats-card title="Sales"
                                type="gradient-green"
                                sub-title="924"
                                icon="ni ni-money-coins"
                                class="mb-4 mb-xl-0">

                        <template slot="footer">
                            <span class="text-danger mr-2"><i class="fa fa-arrow-down"></i> 5.72%</span>
                            <span class="text-nowrap">Since last month</span>
                        </template>
                    </stats-card>

                </div>
                <div class="col-xl-3 col-lg-6">
                    <stats-card title="Performance"
                                type="gradient-info"
                                sub-title="49,65%"
                                icon="ni ni-chart-bar-32"
                                class="mb-4 mb-xl-0">

                        <template slot="footer">
                            <span class="text-success mr-2"><i class="fa fa-arrow-up"></i> 54.8%</span>
                            <span class="text-nowrap">Since last month</span>
                        </template>
                    </stats-card>
                </div>
            </div>
        </base-header>

        <div class="container-fluid mt--7">
            <div class="row mt-5">
                <div class="col">
                    <CategoriesTable @openSub="subopen" v-if="table === 'category' " title="Categories"></CategoriesTable>
                    <SubcategoriesTable @opencat="table = 'category'" @openBrands="brandopen"  v-if="table === 'subcategory' " :title="subcategoryTitle" :id="categories.id" :Cname="categories.name"></SubcategoriesTable>
                    <BrandsTable @openSubcat="table = 'subcategory'" @openProducts="productsOpen" v-if="table === 'brand' " :Cid="categories.id" :Sid="this.categories.subId" :title="brandTitle" :subName='categories.subName'></BrandsTable>
                    <ProductsTable @openBrand="table ='brand' " v-if="table === 'product' " :title="productTitle" :Bid="categories.brandId" :rows='categories.products' :Bname="categories.brandName" ></ProductsTable>
                </div>
            </div>
        </div>
        
    </div>
</template>
<script>
  import CategoriesTable from './Tables/CategoriesTable'
  import SubcategoriesTable from './Tables/SubcategoriesTable'
  import BrandsTable from './Tables/BrandsTable'
  import ProductsTable from './Tables/ProductsTable'
  export default {
    name: 'Categories',
    components: {
      CategoriesTable,
      BrandsTable,
      SubcategoriesTable,
      ProductsTable
    },
     data() {
      return {
          table: 'category',
          categories:{
          id: 0,
          name: '',
          subId: 0,
          subName: '',
          brandId:0,
          brandName:'',
          products:[]

        },
        subcategoryTitle:'',
        brandTitle:'',
        productTitle:''
      }
     },
     methods:{
         subopen(e){
             
             this.categories.id = e.id;
             this.categories.name = e.name;
             this.subcategoryTitle = 'Categories > ';
             this.table = 'subcategory';
         },
         brandopen(e){
            this.categories.subId = e.id;
            this.categories.subName = e.name;
            this.brandTitle = 'Categories > ' + this.categories.name + ' > ';
            this.table = 'brand'
         },
         productsOpen(e){
             this.categories.brandId = e.id;
             this.categories.brandName = e.name;
             this.categories.products = e.products;
             this.productTitle = this.categories.name + ' > ' + 'Subcategories > ' + this.categories.subName + ' > '
             this.table = 'product'
         }
     }
  };
</script>
<style></style>
